import { render, staticRenderFns } from "./discount-amount.vue?vue&type=template&id=3373c138&scoped=true&"
import script from "./discount-amount.vue?vue&type=script&lang=js&"
export * from "./discount-amount.vue?vue&type=script&lang=js&"
import style0 from "./discount-amount.vue?vue&type=style&index=0&id=3373c138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373c138",
  null
  
)

export default component.exports